import { Box } from '@mui/material';
import { LineChart } from '@mui/x-charts';
import React from 'react';

interface Props {
  data: number[];
  labels: string[];
}

const ApplicantsCountChart: React.FC<Props> = ({ data, labels }) => {
  return (
    <Box
      height={300}
      width={"100%"}
    >
      <LineChart
        xAxis={[{
          data: labels.map((_, i) => i),
          scaleType: 'band',
          valueFormatter: (i) => labels[i]
        }]}
        series={[
          {
            data: data,
            label: 'New Applicants',
          },
        ]}
      />
    </Box>
  );
};

export default ApplicantsCountChart;
